import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface IPasswordField {
	changePassword: (value: string) => void;
}

const PasswordField: React.FC<IPasswordField> = ({ changePassword }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterPassword') },
			() => ({
				validator(_, value) {
					if (!value || value.length > 5) {
						return Promise.resolve();
					}
					return Promise.reject(new Error(t('minNumOfChar', { value: '6' })));
				},
			}),
		],
		[t],
	);

	return (
		<FormInput
			testId="PasswordField"
			name="password"
			label="passwordLabel"
			onChange={changePassword}
			validationRules={validationRules}
			type="password"
			allowClear={false}
			iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
		/>
	);
};

export default React.memo(PasswordField);
